import { createAction } from '@'
import { $modalVisible } from '../stores'

export default createAction('SetModalVisible', (name, visible) => {
    $modalVisible.subStore(name).setState(() => visible)
})
